import React, { FC } from 'react';
import ForgotPassword from 'pages/ForgotPassword';
import CreatePassword from 'pages/CreatePassword';
import MyAccount from 'pages/MyAccount';
import Settings from 'pages/Settings';
import { CoreRouter, LogoutRoute } from './utils/coreRouter';
import { Roles } from './constants';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import ResetPassword from '../pages/ResetPassword';
import TwoFactorAuth from '../pages/TwoFactorAuth';
import NewsBuilder from '../pages/NewsBuilder';

const ALL_AUTHENTICATED_ROLES = [Roles.ADMIN, Roles.ZONE_ADMIN, Roles.ZONE_MANAGER, Roles.STAFF];

const Routes: FC = () => (
    <CoreRouter routes={[
        { path: '/', component: Login, type: 'default' },
        { path: '/dashboard', component: Dashboard, type: 'auth', allow: ALL_AUTHENTICATED_ROLES },
        { path: '/my-account', component: MyAccount, type: 'auth', allow: ALL_AUTHENTICATED_ROLES },
        { path: '/settings', component: Settings, type: 'auth', allow: [Roles.ADMIN, Roles.ZONE_ADMIN] },
        { path: '/reset-password/:token/:email', component: ResetPassword, type: 'default' },
        { path: '/create-password/:token/:email', component: CreatePassword, type: 'default' },
        { path: '/forgot-password', component: ForgotPassword, type: 'default' },
        { path: '/news-builder', component: NewsBuilder, type: 'auth', allow: [Roles.ADMIN, Roles.ZONE_ADMIN, Roles.ZONE_MANAGER] },
        { path: '/two-factor', component: TwoFactorAuth, type: 'default' },
        { path: '/logout', component: LogoutRoute, type: 'default' },
    ]} />
);

export default Routes;
